import styles from "./styles";

const FormInformation = () => {
  return (
    <div className={styles.container}>
      <p>
        Vous avez besoin de faire réparer un article que vous possédez déjà ?
        Complétez le formulaire suivant pour effectuer une demande.
      </p>
      <p>
        Nous communiquerons vos coordonnées à notre partenaire de réparation qui
        vous indiquera les options de réparation possibles, les tarifs et la
        procédure à suivre.
      </p>
      <p>
        Si vous souhaitez de l&apos;aide à propos d&apos;une commande ASOS
        récente, veuillez consulter nos pages d&apos;
        <a href="/fr/service-client">aide</a>.
      </p>
    </div>
  );
};

export default FormInformation;
